import card from './card.json';
import chat from './chat.json';
import credit from './credit.json';
import common from './common.json';
import user from './user.json';

const translation = (
  {
    ...card,
    ...chat,
    ...credit,
    ...common,
    ...user,
  }
)

export default translation;